import { render } from "./rep010.vue?vue&type=template&id=fa7a5812&scoped=true"
import script from "./rep010.vue?vue&type=script&lang=js"
export * from "./rep010.vue?vue&type=script&lang=js"

import "./rep010.vue?vue&type=style&index=0&id=fa7a5812&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa7a5812"]])

export default __exports__